import { Text } from '@highlight-cp/core-ui';

interface InlineEditableInputErrorProps {
  error: string | React.ReactNode;
}

const InlineEditableInputError = ({ error }: InlineEditableInputErrorProps) => {
  return (
    <Text size="sm" c="var(--mantine-color-error)" role="alert" aria-live="polite" aria-atomic>
      {error}
    </Text>
  );
};

export default InlineEditableInputError;
